import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/ayanamsa-comparison-calculator/page.tsx");
